/**
 * Content-Design-authored copy for the /sign-in route (design state 1.1,
 * TG-43, Content Design Agent mandatory per the constitution's trigger
 * table for user-facing text).
 *
 * Every string below is copied byte for byte from AC-21 in
 * `specs/features/m1-magic-link-authentication-session/product-spec.md` —
 * no developer-drafted wording, no lorem, no placeholder. `helpLine` is the
 * AC-29 help line shown on views for states 1.1 to 1.4 (not on the AC-25
 * could-not-complete view), passed to `PortalLayout`'s `helpLine` prop.
 *
 * AC-25/AC-26/AC-6/AC-24: this view carries no policy number, renewal date
 * or account name, and no broker or helpdesk contact route.
 *
 * This view carries one email field and one action, matching AC-21's "one
 * email field labelled 'Email address'" and "one action labelled 'Send
 * sign-in link'". The two field-validation messages are the only strings
 * this route conditionally shows, each surfaced both in an error summary
 * headed "There is a problem" and against the field, per AC-21.
 */
export const signInContent = {
  heading: "Sign in to start your renewal",
  body: "Enter your email address and we will send you a link to sign in.",

  emailFieldLabel: "Email address",
  emailFieldHint: "Use the email address your renewal invitation was sent to",

  continueActionLabel: "Send sign-in link",

  errorSummaryHeading: "There is a problem",
  emptyFieldError: "Enter your email address",
  invalidFormatError: "Enter an email address in the correct format, like name@company.com",

  helpLine: "Need help? Contact your Account Manager.",
} as const;
